export default __webpack_public_path__ + "static/media/iphone-11-pro-max.7045a08f.png";